import "vue-select/dist/vue-select.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "@coreui/coreui-pro/dist/css/coreui.min.css";
import "vue-toast-notification/dist/theme-sugar.css";
import "v-calendar/style.css";
import "./polyfill";

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import CoreuiVuePro from "@coreui/vue-pro";
import { createBootstrap } from "bootstrap-vue-next";
import VCalendar from "v-calendar";
// Create App
const app = createApp(App);
// Import Libraries
app.use(store);
app.use(router);
app.use(CoreuiVuePro);
app.use(VCalendar);
app.use(createBootstrap());

// Mount
app.mount("#app");
